import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_CONTRACT_REDUX]'; // eslint-disable-line

const functionDefinitions = {

    /*---------- contractDetail --------*/

    requestContractDetail: ['contractInput', 'actionTab'],
    contractDetailSuccess: ['contractDetailResponse'],
    contractDetailFailure: ['contractDetailError'],
    requestUpdateFinancialStatement: ['financialStatement'],

    /*---------- updateContractDetail --------*/

    requestUpdateContractDetail: ['contractDetail', 'offerId', 'contractId', 'isRedirectToDeed', 'deedId'],
    updateContractDetailSuccess: ['updateContractDetailResponse'],
    updateContractDetailFailure: ['updateContractDetailError'],

    /*---------- updateContractPaymentBreakdown --------*/

    requestupdateContractPaymentBreakdown: ['paymentBreakDowns', 'offerId', 'contractId'],
    updateContractPaymentBreakdownSuccess: ['updateContractPaymentBreakdownResponse'],
    updateContractPaymentBreakdownFailure: ['updateContractPaymentBreakdownError'],

    /*---------- getContractReportText --------*/

    requestGetContractReportText: ['textId', 'editorKey'],
    getContractReportTextSuccess: ['getContractReportTextResponse'],
    getContractReportTextFailure: ['getContractReportTextError'],

    /*---------- updateContractText --------*/

    requestUpdateContractText: ['contractText', 'offerId', 'contractId'],
    updateContractTextSuccess: ['updateContractTextResponse'],
    updateContractTextFailure: ['updateContractTextError'],

    /*---------- updateContractCommission --------*/

    requestUpdateContractCommission: ['contractCommission', 'offerId', 'contractId'],
    updateContractCommissionSuccess: ['updateContractCommissionResponse'],
    updateContractCommissionFailure: ['updateContractCommissionError'],

    /*---------- getDashboardCommission --------*/

    requestGetDashboardCommission: ['userId'],
    getDashboardCommissionSuccess: ['getDashboardCommissionResponse'],
    getDashboardCommissionFailure: ['getDashboardCommissionError'],

    /*---------- restoreContract --------*/

    requestRestoreContract: ['historyId', 'offerId', 'contractId', 'action'],
    restoreContractSuccess: ['restoreContractResponse'],
    restoreContractFailure: ['restoreContractError'],

    /*---------- getEmployeeCommission --------*/

    requestGetEmployeeCommission: ['employeeCommission'],
    getEmployeeCommissionSuccess: ['getEmployeeCommissionResponse'],
    getEmployeeCommissionFailure: ['getEmployeeCommissionError'],

    /*---------- exportAllEmployeeCommission --------*/

    requestExportAllEmployeeCommission: ['allEmployeeCommission'],
    exportAllEmployeeCommissionSuccess: ['exportAllEmployeeCommissionResponse'],
    exportAllEmployeeCommissionFailure: ['exportAllEmployeeCommissionError'],

    /*---------- generateEmpCommission --------*/

    requestGenerateEmpCommission: ['empCommissionInput'],
    generateEmpCommissionSuccess: ['generateEmpCommissionResponse'],
    generateEmpCommissionFailure: ['generateEmpCommissionError'],

    /*---------- searchContact --------*/
    requestSearchContact: ['searchTerm'],
    searchContactSuccess: ['SearchContactResponse'],
    searchContactFailure: ['SearchContactError'],


    /*---------- generateCommissionReport --------*/

    requestGenerateCommissionReport: ['contractId', 'saleId', 'exportType', 'commissionId'],
    generateCommissionReporteSuccess: ['generateCommissionReporteResponse'],
    generateCommissionReporteFailure: ['generateCommissionReporteError'],

    /*---------- generateContractReport --------*/

    requestGenerateContractReport: ['propertyId', 'contractId'],
    generateContractReportSuccess: ['generateContractReportResponse'],
    generateContractReportFailure: ['generateContractReportError'],

    /*---------- clearContactSearch --------*/
    clearContactSearch:[]

};

const { Types, Creators } = createActions(functionDefinitions);

export const SagaContractTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaContractInitState = {
    contractDetail: [],
};

export const INITIAL_STATE = Immutable(SagaContractInitState);

/* ------------- Reducers ------------- */

// export const getUpdatedHistory = (state: Immutable, actionName: string, contractDetail) => {

//     const contractHistory = state.contractHistory ?  Immutable.asMutable(state.contractHistory, { deep: true }) : {};
//     contractHistory[getUnixTimestampInSeconds()] = {
//         action: actionName,
//         contractDetail
//     };
//     return contractHistory;

// };

/*---------- contractDetail --------*/

export const requestContractDetail = (state, action) => {
    return state.merge(
        {
            contractDetailFetching: true,
            contractDetailError: null,
            contractInput: action.contractInput,
            actionTab: action.actionTab,
            contractDetailResponse: null,
        });
};
export const contractDetailSuccess = (state, action) => {
    return state.merge(
        {
            contractDetailFetching: false,
            contractDetailResponse: action.contractDetailResponse,
        });
};
export const contractDetailFailure = (state, action) => {
    return state.merge(
        {
            contractDetailFetching: false,
            contractDetailError: action.contractDetailError,

        });
};

export const requestUpdateFinancialStatement = (state, action) => {

    const contractDetailResponse = { ...state.contractDetailResponse };
    contractDetailResponse.financialStatement = action.financialStatement;
    return state.merge(
        {
            contractDetailResponse
        });
};

/*---------- updateContractDetail --------*/


export const requestUpdateContractDetail = (state, action) => {
    return state.merge(
        {
            updateContractDetailFetching: true,
            updateContractDetailError: null,
            contractDetail: action.contractDetail,
            offerId: action.offerId,
            contractId: action.contractId,
            isRedirectToDeed: action.isRedirectToDeed,
            deedId: action.deedId,
        });
};
export const updateContractDetailSuccess = (state, action) => {
    return state.merge(
        {
            updateContractDetailFetching: false,
            updateContractDetailResponse: action.updateContractDetailResponse,
            // contractHistory:getUpdatedHistory(state,action.type,action.updateContractDetailResponse)
        });
};
export const updateContractDetailFailure = (state, action) => {
    return state.merge(
        {
            updateContractDetailFetching: false,
            updateContractDetailError: action.updateContractDetailError,
        });
};

/*---------- updateContractPaymentBreakdown --------*/


export const requestupdateContractPaymentBreakdown = (state, action) => {
    return state.merge(
        {
            updateContractPaymentBreakdownFetching: true,
            updateContractPaymentBreakdownError: null,
            paymentBreakDowns: action.paymentBreakDowns,
            offerId: action.userId,
            contractId: action.contractId
        });
};
export const updateContractPaymentBreakdownSuccess = (state, action) => {
    return state.merge(
        {
            updateContractPaymentBreakdownFetching: false,
            updateContractPaymentBreakdownResponse: action.updateContractPaymentBreakdownResponse,
            contractDetailResponse: action.updateContractPaymentBreakdownResponse
        });
};
export const updateContractPaymentBreakdownFailure = (state, action) => {
    return state.merge(
        {
            updateContractPaymentBreakdownFetching: false,
            updateContractPaymentBreakdownError: action.updateContractPaymentBreakdownError
        });
};

/*---------- getContractReportText --------*/


export const requestGetContractReportText = (state, action) => {
    return state.merge(
        {
            getContractReportTextFetching: true,
            textId: action.textId,
            editorKey: action.editorKey,
            getContractReportTextError: null,
            getContractReportTextResponse: null,
        });
};
export const getContractReportTextSuccess = (state, action) => {
    return state.merge(
        {
            getContractReportTextFetching: false,
            getContractReportTextResponse: action.getContractReportTextResponse,
        });
};
export const getContractReportTextFailure = (state, action) => {
    return state.merge(
        {
            getContractReportTextFetching: false,
            getContractReportTextError: action.getContractReportTextError,
        });
};


/*---------- updateContractText --------*/


export const requestUpdateContractText = (state, action) => {
    return state.merge(
        {
            updateContractTextFetching: true,
            updateContractTextResponse: null,
            updateContractTextError: null,
            contractText: action.contractText,
            userId: action.userId,
            offerId: action.userId,
            contractId: action.contractId
        });
};
export const updateContractTextSuccess = (state, action) => {
    return state.merge(
        {
            updateContractTextFetching: false,
            updateContractTextResponse: action.updateContractTextResponse,
            // contractHistory:getUpdatedHistory(state,action.type,action.updateContractTextResponse)
        });
};
export const updateContractTextFailure = (state, action) => {
    return state.merge(
        {
            updateContractTextFetching: false,
            updateContractTextError: action.updateContractTextError,

        });
};

/*---------- updateContractCommission --------*/


export const requestUpdateContractCommission = (state, action) => {
    return state.merge(
        {
            updateContractCommissionFetching: true,
            contractCommission: action.contractCommission,
            updateContractCommissionError: null,
            updateContractCommissionResponse: null,
            offerId: action.userId,
            contractId: action.contractId
        });
};
export const updateContractCommissionSuccess = (state, action) => {
    return state.merge(
        {
            updateContractCommissionFetching: false,
            updateContractCommissionResponse: action.updateContractCommissionResponse,
            // contractHistory:getUpdatedHistory(state,action.type,action.updateContractCommissionResponse)
        });
};
export const updateContractCommissionFailure = (state, action) => {
    return state.merge(
        {
            updateContractCommissionFetching: false,
            updateContractCommissionError: action.updateContractCommissionError,

        });
};

/*---------- getDashboardCommission --------*/

export const requestGetDashboardCommission = (state, action) => {
    return state.merge(
        {
            getDashboardCommissionFetching: true,
            userId: action.userId,
            getDashboardCommissionError: null,
            getDashboardCommissionResponse: null,
        });
};
export const getDashboardCommissionSuccess = (state, action) => {
    return state.merge(
        {
            getDashboardCommissionFetching: false,
            getDashboardCommissionResponse: action.getDashboardCommissionResponse,
        });
};
export const getDashboardCommissionFailure = (state, action) => {
    return state.merge(
        {
            getDashboardCommissionFetching: false,
            getDashboardCommissionError: action.getDashboardCommissionError,
        });
};

/*---------- restoreContract --------*/


export const requestRestoreContract = (state, action) => {
    return state.merge(
        {
            restoreContractFetching: true,
            restoreContractResponse: null,
            restoreContractError: null,
            historyId: action.historyId,
            offerId: action.offerId,
            contractId: action.contractId,
            action: action.action,
        });
};
export const restoreContractSuccess = (state, action) => {
    return state.merge(
        {
            restoreContractFetching: false,
            restoreContractResponse: action.restoreContractResponse,
        });
};
export const restoreContractFailure = (state, action) => {
    return state.merge(
        {
            restoreContractFetching: false,
            restoreContractError: action.restoreContractError,
        });
};

/*---------- getEmployeeCommission --------*/

export const requestGetEmployeeCommission = (state, action) => {
    return state.merge(
        {
            getEmployeeCommissionFetching: true,
            getEmployeeCommissionResponse: null,
            getEmployeeCommissionError: null,
            employeeCommission: action.employeeCommission,
        });
};
export const getEmployeeCommissionSuccess = (state, action) => {
    return state.merge(
        {
            getEmployeeCommissionFetching: false,
            getEmployeeCommissionResponse: action.getEmployeeCommissionResponse,
            getEmployeeCommissionError: null
        });
};
export const getEmployeeCommissionFailure = (state, action) => {
    return state.merge(
        {
            getEmployeeCommissionFetching: false,
            getEmployeeCommissionError: action.getEmployeeCommissionError,
            getEmployeeCommissionResponse: null
        });
};

/*---------- exportAllEmployeeCommission --------*/

export const requestExportAllEmployeeCommission = (state, action) => {
    return state.merge(
        {
            exportAllEmployeeCommissionFetching: true,
            allEmployeeCommission: action.allEmployeeCommission,
            exportAllEmployeeCommissionResponse: null,
            exportAllEmployeeCommissionError: null,
        });
};
export const exportAllEmployeeCommissionSuccess = (state, action) => {
    return state.merge(
        {
            exportAllEmployeeCommissionFetching: false,
            exportAllEmployeeCommissionResponse: action.exportAllEmployeeCommissionResponse,
        });
};
export const exportAllEmployeeCommissionFailure = (state, action) => {
    return state.merge(
        {
            exportAllEmployeeCommissionFetching: false,
            exportAllEmployeeCommissionError: action.exportAllEmployeeCommissionError,
        });
};

/*---------- generateEmpCommission --------*/


export const requestGenerateEmpCommission = (state, action) => {
    return state.merge(
        {
            generateEmpCommissionFetching: true,
            empCommissionInput: action.empCommissionInput,
            generateEmpCommissionError: null,
            generateEmpCommissionResponse: null
        });
};
export const generateEmpCommissionSuccess = (state, action) => {
    return state.merge(
        {
            generateEmpCommissionFetching: false,
            generateEmpCommissionResponse: action.generateEmpCommissionResponse,

        });
};
export const generateEmpCommissionFailure = (state, action) => {
    return state.merge(
        {
            generateEmpCommissionFetching: false,
            generateEmpCommissionError: action.generateEmpCommissionError,

        });
};

/*---------- searchContact --------*/


export const requestSearchContact = (state: Immutable, action) => {
    return state.merge(
        {
            searchContactFetching: true,
            searchTerm: action.searchTerm,

        });
};
export const searchContactSuccess = (state: Immutable, action) => {
    return state.merge(
        {
            searchContactFetching: false,
            SearchContactResponse: action.SearchContactResponse
        });
};
export const searchContactFailure = (state: Immutable, action) => {
    return state.merge(
        {
            searchContactFetching: false,
            SearchContactError: action.SearchContactError,

        });
};


/*---------- generateCommissionReport --------*/


export const requestGenerateCommissionReport = (state: Immutable) => {
    return state.merge(
        {
            generateCommissionReportFetching: true
        });
};
export const generateCommissionReporteSuccess = (state: Immutable, action) => {
    return state.merge(
        {
            generateCommissionReportFetching: false,
            generateCommissionReporteResponse: action.generateCommissionReporteResponse,
            generateCommissionReporteError: null

        });
};
export const generateCommissionReporteFailure = (state: Immutable, action) => {
    return state.merge(
        {
            generateCommissionReportFetching: false,
            generateCommissionReporteError: action.generateCommissionReporteError,

        });
};

/*---------- generateContractReport --------*/


export const requestGenerateContractReport = (state, action) => {
    return state.merge(
        {
            generateContractReportFetching: true,
            contractId: action.contractId,
            propertyId: action.propertyId,
            generateContractReportResponse: null
        });
};
export const generateContractReportSuccess = (state, action) => {
    return state.merge(
        {
            generateContractReportFetching: false,
            generateContractReportResponse: action.generateContractReportResponse,
            generateContractReportError: null
        });
};
export const generateContractReportFailure = (state, action) => {
    return state.merge(
        {
            generateContractReportFetching: false,
            generateContractReportError: action.generateContractReportError,
        });
};

/*---------- clearContactSearch --------*/
export const clearContactSearch = (state,action) => {
    return state.merge(
      {
        SearchContactResponse: null,
      });
  };




/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {

    /*---------- contractDetail --------*/

    [Types.REQUEST_CONTRACT_DETAIL]: requestContractDetail,
    [Types.CONTRACT_DETAIL_SUCCESS]: contractDetailSuccess,
    [Types.CONTRACT_DETAIL_FAILURE]: contractDetailFailure,
    [Types.REQUEST_UPDATE_FINANCIAL_STATEMENT]: requestUpdateFinancialStatement,
    /*---------- updateContractDetail --------*/

    [Types.REQUEST_UPDATE_CONTRACT_DETAIL]: requestUpdateContractDetail,
    [Types.UPDATE_CONTRACT_DETAIL_SUCCESS]: updateContractDetailSuccess,
    [Types.UPDATE_CONTRACT_DETAIL_FAILURE]: updateContractDetailFailure,

    /*---------- updateContractPaymentBreakdown --------*/

    [Types.REQUESTUPDATE_CONTRACT_PAYMENT_BREAKDOWN]: requestupdateContractPaymentBreakdown,
    [Types.UPDATE_CONTRACT_PAYMENT_BREAKDOWN_SUCCESS]: updateContractPaymentBreakdownSuccess,
    [Types.UPDATE_CONTRACT_PAYMENT_BREAKDOWN_FAILURE]: updateContractPaymentBreakdownFailure,

    /*---------- getContractReportText --------*/

    [Types.REQUEST_GET_CONTRACT_REPORT_TEXT]: requestGetContractReportText,
    [Types.GET_CONTRACT_REPORT_TEXT_SUCCESS]: getContractReportTextSuccess,
    [Types.GET_CONTRACT_REPORT_TEXT_FAILURE]: getContractReportTextFailure,

    /*---------- updateContractText --------*/

    [Types.REQUEST_UPDATE_CONTRACT_TEXT]: requestUpdateContractText,
    [Types.UPDATE_CONTRACT_TEXT_SUCCESS]: updateContractTextSuccess,
    [Types.UPDATE_CONTRACT_TEXT_FAILURE]: updateContractTextFailure,

    /*---------- updateContractCommission --------*/

    [Types.REQUEST_UPDATE_CONTRACT_COMMISSION]: requestUpdateContractCommission,
    [Types.UPDATE_CONTRACT_COMMISSION_SUCCESS]: updateContractCommissionSuccess,
    [Types.UPDATE_CONTRACT_COMMISSION_FAILURE]: updateContractCommissionFailure,

    /*---------- getDashboardCommission --------*/

    [Types.REQUEST_GET_DASHBOARD_COMMISSION]: requestGetDashboardCommission,
    [Types.GET_DASHBOARD_COMMISSION_SUCCESS]: getDashboardCommissionSuccess,
    [Types.GET_DASHBOARD_COMMISSION_FAILURE]: getDashboardCommissionFailure,

    /*---------- restoreContract --------*/

    [Types.REQUEST_RESTORE_CONTRACT]: requestRestoreContract,
    [Types.RESTORE_CONTRACT_SUCCESS]: restoreContractSuccess,
    [Types.RESTORE_CONTRACT_FAILURE]: restoreContractFailure,

    /*---------- getEmployeeCommission --------*/

    [Types.REQUEST_GET_EMPLOYEE_COMMISSION]: requestGetEmployeeCommission,
    [Types.GET_EMPLOYEE_COMMISSION_SUCCESS]: getEmployeeCommissionSuccess,
    [Types.GET_EMPLOYEE_COMMISSION_FAILURE]: getEmployeeCommissionFailure,

    /*---------- exportAllEmployeeCommission --------*/

    [Types.REQUEST_EXPORT_ALL_EMPLOYEE_COMMISSION]: requestExportAllEmployeeCommission,
    [Types.EXPORT_ALL_EMPLOYEE_COMMISSION_SUCCESS]: exportAllEmployeeCommissionSuccess,
    [Types.EXPORT_ALL_EMPLOYEE_COMMISSION_FAILURE]: exportAllEmployeeCommissionFailure,

    /*---------- generateEmpCommission --------*/

    [Types.REQUEST_GENERATE_EMP_COMMISSION]: requestGenerateEmpCommission,
    [Types.GENERATE_EMP_COMMISSION_SUCCESS]: generateEmpCommissionSuccess,
    [Types.GENERATE_EMP_COMMISSION_FAILURE]: generateEmpCommissionFailure,

    /*---------- searchContact --------*/

    [Types.REQUEST_SEARCH_CONTACT]: requestSearchContact,
    [Types.SEARCH_CONTACT_SUCCESS]: searchContactSuccess,
    [Types.SEARCH_CONTACT_FAILURE]: searchContactFailure,


    /*---------- generateCommissionReport --------*/

    [Types.REQUEST_GENERATE_COMMISSION_REPORT]: requestGenerateCommissionReport,
    [Types.GENERATE_COMMISSION_REPORTE_SUCCESS]: generateCommissionReporteSuccess,
    [Types.GENERATE_COMMISSION_REPORTE_FAILURE]: generateCommissionReporteFailure,

    /*---------- generateContractReport --------*/

    [Types.REQUEST_GENERATE_CONTRACT_REPORT]: requestGenerateContractReport,
    [Types.GENERATE_CONTRACT_REPORT_SUCCESS]: generateContractReportSuccess,
    [Types.GENERATE_CONTRACT_REPORT_FAILURE]: generateContractReportFailure,

    /*---------- clearContactSearch --------*/
    [Types.CLEAR_CONTACT_SEARCH]: clearContactSearch,

});



// WEBPACK FOOTER //
// ./src/redux/sagaContract/sagaContractRedux.ts